module.exports = __webpack_public_path__ + "img/figure-9.ebe37cb0.png";